import { UrlUtil } from './url-util';
import { AppStoreLinksService } from './appStoreLinks.service';
import { AnalyticsData } from '../../../models/analytics-data';
import { MobileAppLinks } from '../../../models/mobile-app-links';
import { FeatureFlagsService } from './feature-flags.service';
import { FeatureFlagDictionaryEnum } from 'src/app/shared/enums';

export class UrlRoyalService {
	private util: UrlUtil;
	private appStoreService: AppStoreLinksService;

	constructor(private urls: any, private wul: string, private featureFlagsService: FeatureFlagsService) {
		this.util = new UrlUtil();
		this.appStoreService = new AppStoreLinksService();
	}

	aboutUs(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: 'royalcaribbean.com/aboutus',
			au: 'rclcorporate.com',
			br: 'rclcorporate.com',
			espanol: 'rclcorporate.com',
			com: 'royalcaribbean.com/aboutus'
		};

		return this.util.getMappedUrl(urlMap, 'royalcaribbean.com/aboutus', src);
	}

	contactUs(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/customersupport/contactUs.do',
			au: '/customersupport/contactUs.do',
			br: '/customersupport/contactUs.do',
			espanol: '/customersupport/contactUs.do',
			com: '/customersupport/contactUs.do'
		};

		return this.util.getMappedUrl(urlMap, 'royalcaribbean.com/customersupport/contactUs.do', src);
	}

	privacyPolicy(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/privacyPolicy.do',
			au: '/privacyPolicy.do',
			br: '/privacyPolicy.do',
			espanol: '/privacyPolicy.do',
			com: '/resources/privacy-policy'
		};

		return this.util.getMappedUrl(urlMap, 'royalcaribbean.com/resources/privacy-policy', src);
	}

	legal(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/legal.do',
			au: '/contentPage.do?pagename=terms_and_conditions_australia',
			br: '/legal.do',
			espanol: '/legal.do',
			com: '/terms-and-conditions/digital-terms-of-use-and-end-user-license-agreement'
		};

		return this.util.getMappedUrl(
			urlMap,
			'royalcaribbean.com/terms-and-conditions/digital-terms-of-use-and-end-user-license-agreement',
			src
		);
	}

	siteMap(src?: string) {
		return '/statichtmlpage.do?pagename=sitemap';
	}

	faq(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: '/customersupport/faq/subject.do?snav=2&faqSubjectName=Check-in+online&faqSubjectId=328&pnav=5',
			au: '/faq/topics/online-check-in-boarding',
			br: '/customersupport/faq/subject.do?snav=2&faqSubjectName=Check-in+online&faqSubjectId=328&pnav=5',
			espanol: '/customersupport/faq/subject.do?snav=2&faqSubjectName=Check-in+online&faqSubjectId=328&pnav=5',
			com: '/faq/topics/online-check-in-boarding'
		};

		return this.util.getMappedUrl(urlMap, 'https://www.royalcaribbean.com/faq/topics/online-check-in-boarding', src) ||
			'/faq/topics/online-check-in-boarding';
	}

	curtesyHolds(src?: string) {
		return null; // null means do not show on UI
	}

	royalGifts(src?: string) {
		return '/royalgifts/';
	}

	private isNewGAEnabled(): boolean {
		const flags = this.featureFlagsService.snapshot;
		return flags?.[FeatureFlagDictionaryEnum.NEW_GA_DASHBOARD_ENABLED] || false;
	}

	upcomingCruises(src?: string) {
		return this.isNewGAEnabled() ? '/myaccount/my-trips?tab=upcoming' : '/account/upcoming-cruises';
	}

	pastCruises(src?: string) {
		return this.isNewGAEnabled() ? '/myaccount/my-trips?tab=past' : '/account/past-cruises';
	}

	cubaAffidavitLink(src?: string) {
		const urlMap: { [origin: string]: string } = {
			es: 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba',
			au: 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba',
			br: 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba',
			espanol: 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba',
			com: 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba'
		};
		return this.util.getMappedUrl(urlMap, 'royalcaribbean.com/cruise-destinations/a-quick-guide-to-cruising-to-cuba', src);
	}

	riskAcknowledgementContactUs() {
		return `https://www.royalcaribbean.com/healthycontacts?wul=${this.wul}`;
	}

	mobileAppLinks(payload: AnalyticsData): MobileAppLinks {
		return this.appStoreService.getStoreAppLinks(this.urls, payload);
	}
}
